import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
}

const styles: IStyles = {
  wrapper: {
    alignItems: 'center',
    minWidthMobileLg: {
      display: 'none',
    },
  },
};

export default styles;
